import React from "react";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import BusinessImpactSection from "./layout/BusinessImpactSection";
import CapabilityCardsSection from "./layout/CapabilityCardsSection";

const banner = {
  background: "content/energybanner1.png",
  Title: "OUR BUSINESS",
  childTitle: "POWER, RENEWABLE ENERGY &<br/>INDUSTRIAL INFRASTRUCTURE",
  desktopCol: "8"
}

const impactSection = {
  titleLines: [
    "POWERING THE",
    "INFRASTRUCTURE OF TOMORROW"
  ],
  paragraphs: [
    "Powering the Infrastructure of Tomorrow",
    "HMG supports the development, sourcing, and execution of energy infrastructure across conventional power, renewable energy, smart grids, offshore energy, and industrial power systems.",
    "Through our global procurement network, EPC partnerships, and engineering coordination capabilities, we connect energy developers, utilities, contractors, manufacturers, and industrial clients with the technologies, materials, and execution support required to deliver resilient, efficient, and future-ready projects.",
    "Our Energy Solutions platform spans both established and next-generation energy ecosystems—from oil and gas, power generation, and industrial utilities to offshore wind, solar energy, smart energy management, and the critical electrical infrastructure powering AI data centers, smart cities, and industrial growth."
  ],
  image: "content/energy1.png",
  imageAlt: "Energy infrastructure"
};

const coreCapabilities = [
  {
    number: "01",
    title: "POWER PLANT & ENERGY ENGINEERING",
    image: "content/energy1.png"
  },
  {
    number: "02",
    title: "RENEWABLE ENERGY & CLEAN POWER DEVELOPMENT",
    image: "content/energy2.png"
  },
  {
    number: "03",
    title: "SMART GRID & ENERGY MANAGEMENT",
    image: "content/energy3.png"
  },
  {
    number: "04",
    title: "INDUSTRIAL POWER & CABLE INFRASTRUCTURE",
    image: "content/energy4.png"
  },
  {
    number: "05",
    title: "OIL & GAS INFRASTRUCTURE",
    image: "content/energy5.png"
  },
  {
    number: "06",
    title: "OFFSHORE & MARINE ENERGY SYSTEMS",
    image: "content/energy6.png"
  }
];

class EnergySolutions extends React.Component {
  render() {
    return (
      <>
        <DemoNavbar />
        <main className="food commodity-supply-chain-page energy-solutions-page" ref="main">
          <ChildPageBanner banner={banner} />
          <BusinessImpactSection {...impactSection} />
          <CapabilityCardsSection
            heading="CORE ENERGY SOLUTIONS"
            capabilities={coreCapabilities}
            gridClassName="supply-chain-capabilities-grid--six"
          />
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default EnergySolutions;
